<template>
  <div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="8">
    <div class="container m-auto">
      <div class="mb-10">
        <div class="flex flex-wrap justify-center" v-lazy-container="{ selector: 'img' }">
          <div class="w-full w-full lg:w-9/12 bg-primary-300 rounded-md p-6">
            <div class="flex flex-wrap">
              <div class="w-full lg:w-1/2">
                <a href="#" class="text-secondary-300 font-semibold text-lg mt-20 block">
                  <i class="fas fa-folder-open ml-4"></i>{{ brand.name }}
                </a>
              </div>
              <div class="w-full lg:w-1/2 justify-last">
                <figure class="h-56">
                  <img class="h-full w-full object-contain" :data-src="brand.image ? brand.image :'/front/img/dummy_data/banner1.png'" :alt="brand.name">
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap content-center justify-start">
        <div class="w-full sm:w-6/12 lg:w-9/12">
          <ul class="breadcrumb text-sm md:text-base pt-2">
            <li>
              <a href="/">الرئيسية</a>
            </li>
            <li class="is-active">
              <p>{{ brand.name }}</p>
            </li>
          </ul>
        </div>
        <div class="w-full sm:w-6/12 lg:w-3/12">
          <div class="filter">
            <form class="">
              <label class="flex text-secondary-300 text-sm font-semibold">
                <span class="flex-shrink-0 self-center rtl:ml-4 ltr:mr-4">{{ t('order_by') }}</span>
                <div class="select block w-full">
                  <select class="form-select w-full border-secondary-300 rounded-lg text-sm" v-model="orderBy" name="brand_filter">
                    <option selected value="name">{{ t('name') }}</option>
                    <option value="created_at">{{ t('last_added')}}</option>
                    <option value="views">{{ t('views') }}</option>
                    <option value="price_desc">{{ t('high_price')  }}</option>
                    <option value="price_asc">{{ t('low_price') }}</option>
                  </select>
                </div>
              </label>
            </form>
          </div>
        </div>
        <div class="w-full px-5 lg:px-1 md:px-1 py-3 mt-8">
          <div class="flex flex-wrap content-center justify-start w-full xl:w-12/12 w mx-auto" v-lazy-container="{ selector: 'img' }">
            <product-card v-for="product in products" :key="product.id" :sitelocale="lang" :auth="auth" :product="product" :is-fav="'true'"
                          fav-route="#" compare="#" :slider="false" card-width="sm:w-1/2 md:w-4/12 lg:w-3/12"></product-card>
          </div>
          <div class="has-text-centered m-t-30" v-show="loadMore">
            <a href="#" class="load-more">
              <img src="/front/img/illustrations/load_more.svg">
              <span>{{ t('more') }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import infiniteScroll from 'vue-infinite-scroll';
  export default {
    name: "BrandFilter",
    directives: {
      infiniteScroll
    },
    props: {
      lang:{
        type: String,
        required: true
      },
      brand: {
        type: Object,
        required: true
      },
      url: String,
      currency: String,
    auth: {
      type: String,
      required: true
    }
    },
    computed: {
      busy() {
        return this.fetching
      }
    },
    mounted() {
      this.$translate.setLang(this.lang);
    },
    data(){
      return {
        currentPage: 0,
        page: 1,
        fetching: true,
        nextUrl : String,
        loadMore : false,
        orderBy: 'name',
        products: [],
        sortOrder: 'desc',
        filter: 'name',
        mobile:false,
        activeItem: null,
        activeIndex:null,
      };
    },
    created() {
      this.nextUrl = this.url;
      this.products = [];
      this.loadNextPage();
    },
    methods: {
      loadNextPage() {
        this.getOrderBy(this.orderBy);
        this.currentPage++;
        this.fetching = true;
        if(this.nextUrl != null){
          axios.get(this.nextUrl,
          {
            params : {
              'orderBy' : this.filter, 'direction' : this.sortOrder,
            }
          }

          ).then(({ data }) => {
            this.products.push(...data.data);
            if(data.links.next != null) {
              this.nextUrl = data.links.next;
            } else {
              this.nextUrl = data.links.next;
            }
            this.fetching = false;
          });
        }
        else{
          this.loadMore = false;
        }
      },
      getOrderBy(val) {
        if(val == 'price_asc') {
          this.sortOrder = 'asc';
          this.filter = 'price';
        } else if(val == 'price_desc') {
          this.sortOrder = 'desc';
          this.filter = 'price';
        } else {
          this.sortOrder = 'desc';
          this.filter = val;
        }
      },
      controlCollapse(item , el , event , index , increment){
        this.activeIndex = increment;
        if(item == this.activeItem){
          this.activeItem= null
        }else{
          this.activeItem = item;
        }
        if(this.activeItem){
          setTimeout(() => {
            this.$refs.sub.classList.contains("is-active") ? this.$refs.sub.classList.remove('is-active') : '';        
            if(this.$refs.sub.classList.contains("is-active")){
              this.$refs.sub.classList.remove('is-active') ;
            }
            else{
              this.$refs.sub.classList.add('is-active') ;
            }
          }, 100)
        }
      },
    },
    watch: {
      orderBy: function (val) {
        this.getOrderBy(val);
        this.products = [];
        axios.get(`/brands/${this.brand.slug}`,
        {
          params : {
            'orderBy' : this.filter, 'direction' : this.sortOrder,
            'min_price' : this.min_price, 'max_price' : this.max_price,
          }
        }
        )
        .then(({data}) => {
          this.products = data.data;
          if(data.links.next != null) {
            this.loadMore = true;
            this.nextUrl = data.links.next;
          } else {
            this.nextUrl = data.links.next;
            this.loadMore = false;

          }
          this.currentPage = 0;
          this.fetching = false;
        });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Brands/BrandFilter.vue